/* eslint-disable default-param-last */
/* axios with abort */

import axios from 'axios';
import jwt from 'jsonwebtoken';
import { jwtKeys } from '../utils/config';
import { encrypt } from '../utils/encryptionDecryption';

// import getAuthToken from '../utils/getAuthToken';
import getClientId from '../utils/getClientId';
// import { META_DATA_ENDPOINT, PRODUCTION_ENVIORNMENT } from '../utils/config';
import history from './history';

const ABORTED_MESSAGE = 'request aborted';

const callAPI = (
  apiURL,
  apiMethod,
  apiData = null,
  dummytoken,
  resolveDataAsReponse = false,
  abort = false,
  setLastAPICall,
  getLastAPICall,
  baseAPIURL,
  contentType = 'application/json',
  // headerRequired = true,
  responseType = 'application/json',
) => {
  const CLIENT_ID = getClientId(apiURL);
  // const CLIENT_SECRET = '';
  // const token = getAuthToken('token') || getAuthToken('token-exp');
  // const requestSource = axios.CancelToken.source();

  if (abort && getLastAPICall && getLastAPICall(baseAPIURL)) {
    getLastAPICall(baseAPIURL).cancel(ABORTED_MESSAGE);
  }
  // if (process.env.NODE_ENV === 'test') {
  //   return Promise.resolve();
  // }
  // if (setLastAPICall) {
  //   setLastAPICall(requestSource, baseAPIURL);
  // }

  // program to get a random item from an array

  const otherSocketUniqueId = localStorage.getItem('uniqueId');
  const getRandomItem = arr => {
    const randomIndex = Math.floor(Math.random() * arr.length);
    const item = arr[randomIndex];
    return item;
  };

  const result = getRandomItem(jwtKeys.staticUniqueKey);
  const token = `Bearer ${jwt.sign(
    {
      uniqueId: encrypt(result),
      otherUniqueId: encrypt(otherSocketUniqueId),
    },
    jwtKeys.secretKey,
  )}`;

  // const token = `bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVJZCI6IjM0YWIyMzA1N2RmMDUyNTgwZmIxZTY3MjA4MjIxZjRkIiwib3RoZXJVbmlxdWVJZCI6IjM0YWIyMzA1N2RmMDUyNTgwZmIxZTY3MjA4MjIxZjRkIiwiaWF0IjoxNjU5OTg1NTMxfQ.f5Midw7iHRk0GQjmnT0cxCPRnt2G6d5CfkMWBXpj2pc`;
  const headers = {
    Authorization: token,
    'Content-Type': contentType,
    xclientid: CLIENT_ID,
  };

  // if (META_DATA_ENDPOINT === apiURL) {
  //   if (PRODUCTION_ENVIORNMENT) {
  //     headers = {
  //       Authorization: token,
  //       'Content-Type': contentType,
  //       'x-api-key': 'yFxaTyRTiH7YBUYeYiEeCYBMRGZA8wk5fsCJxVy1',
  //       xclientid: CLIENT_ID,
  //     };
  //   } else {
  //     headers = {
  //       Authorization: token,
  //       'Content-Type': contentType,
  //     };
  //   }
  // } else if (!headerRequired) {
  //   headers = {
  //     'Content-Type': contentType,
  //     xclientid: CLIENT_ID,
  //     xclientsecret: CLIENT_SECRET,
  //     'x-api-key': 'yFxaTyRTiH7YBUYeYiEeCYBMRGZA8wk5fsCJxVy1',
  //   };
  // }

  return new Promise((resolve, reject) => {
    axios({
      url: apiURL,
      method: apiMethod,
      data: apiData,
      // cancelToken: requestSource.token,
      headers,
      responseType,
    })
      .then(response => {
        if (resolveDataAsReponse) {
          resolve(apiData);
        } else {
          resolve(response);
        }
      })
      .catch(err => {
        if (err.response && err.response.status === 401) {
          // if (
          //   history.location.pathname.includes('login') &&
          //   !Cookies.get('token')
          //   // eslint-disable-next-line no-empty
          // ) {
          // } else {
          //   Cookies.remove('token');
          //   Cookies.remove('token-exp');
          //   Cookies.remove('defaultCalendarView');
          history.push('/logout');
          // }
        }

        if (!axios.isCancel(err) && err.response) {
          reject(err.response);
        }
      });
  });
};

export default callAPI;
